"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { toast } from "sonner";
import { Card, CardContent, CardHeader } from "@/components/ui/Card";
import { Button } from "@/components/ui/Button";
import { Badge } from "@/components/ui/Badge";

export function SeedDataPanel() {
  const [isLoading, setIsLoading] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);
  const router = useRouter();

  async function handleLoadSeed() {
    setIsLoading(true);
    try {
      const res = await fetch("/api/seed/jewelry", { method: "POST" });
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.error || "Failed to load jewelry demo data");
      }
      toast.success("Jewelry demo data loaded. Refreshing...");
      router.refresh();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Failed to load demo data");
    } finally {
      setIsLoading(false);
    }
  }

  async function handleRemoveSeed() {
    setIsRemoving(true);
    try {
      const res = await fetch("/api/seed/jewelry", { method: "DELETE" });
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.error || "Failed to remove demo data");
      }
      toast.success("Demo data removed. Refreshing...");
      router.refresh();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Failed to remove demo data");
    } finally {
      setIsRemoving(false);
    }
  }

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-white">Demo Data</h3>
          <Badge variant="info">Jewelry</Badge>
        </div>
      </CardHeader>
      <CardContent>
        <p className="mb-4 text-sm text-text-muted">
          Load a curated set of jewelry inventory, VIP clients, anniversaries, wishlists, layaways, and repairs so you can
          explore every Facet workflow with realistic data.
        </p>
        <div className="flex gap-3">
          <Button
            onClick={handleLoadSeed}
            loading={isLoading}
            disabled={isLoading || isRemoving}
            size="sm"
          >
            Load Jewelry Demo
          </Button>
          <Button
            onClick={handleRemoveSeed}
            loading={isRemoving}
            disabled={isLoading || isRemoving}
            variant="danger"
            size="sm"
          >
            Remove Demo Data
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
